module.exports = __webpack_public_path__ + "static/img/encased-industrial-beam_256.1aec795.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/encased-industrial-beam_256.png
// module id = 0gY7
// module chunks = 0